module.exports = __webpack_public_path__ + "Tinebase/js/ace-html_elixir-FAT.js";